import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, EmptyCell, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const BrickellFirstMatrix = props => {

    const { data: _data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    const data = Object.fromEntries(
        Object.entries(_data || {}).map(([key, value]) => [key.split('-')[1], value])
    );

    if (!_data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>
            <Title data={Object.values(data)} title='Brickell First'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='6' content='South View' />
                        <Header colSpan='4' content='East View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='S-2/2' />
                        <Header colSpan='2' content='P-2/2' />
                        <Header colSpan='2' content='P2-2/2' />
                        <Header colSpan='2' content='A1-2/2' />
                        <Header colSpan='2' content='B-1/1' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1249 sq ft' />
                        <Header colSpan='2' content='1155 sq ft' />
                        <Header colSpan='2' content='1156 sq ft' />
                        <Header colSpan='2' content='982 sq ft' />
                        <Header colSpan='2' content='805 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        range(22, 6, -1)
                            .filter(num => num !== 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(num => (
                                <Table.Row key={num}>
                                    <Cell unit={`${num}08`} price={renderPrice(data[`${num}08`], matrixType)} status={data[`${num}08`].status}/>
                                    <EmptyCell count={2} />
                                    <Cell unit={`${num}06`} price={renderPrice(data[`${num}06`], matrixType)} status={data[`${num}06`].status}/>
                                    <Cell unit={`${num}04`} price={renderPrice(data[`${num}04`], matrixType)} status={data[`${num}04`].status}/>
                                </Table.Row>
                            ))
                    }

                    <Table.Row>
                        <EmptyCell count={4} />
                        <Cell unit='0604' price={renderPrice(data['0604'], matrixType)} status={data['0604'].status}/>
                    </Table.Row>

                    <Table.Row>
                        <EmptyCell />
                        <Cell unit='0401' price={renderPrice(data['0401'], matrixType)} status={data['0401'].status}/>
                        <EmptyCell count={3} />
                    </Table.Row>

                    <Table.Row>
                        <EmptyCell/>
                        <Cell unit='0301' price={renderPrice(data['0301'], matrixType)} status={data['0301'].status}/>
                        <Cell unit='0302' price={renderPrice(data['0302'], matrixType)} status={data['0302'].status}/>
                        <EmptyCell count={2} />
                    </Table.Row>

                    <Table.Row>
                        <EmptyCell />
                        <Cell unit='0201' price={renderPrice(data['0201'], matrixType)} status={data['0201'].status}/>
                        <Cell unit='0202' price={renderPrice(data['0202'], matrixType)} status={data['0202'].status}/>
                        <EmptyCell count={2} />
                    </Table.Row>

                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />

            <Title title='Brickell First'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>

                <Table.Header>
                    <Table.Row>
                        <Header colSpan='4' content='North View' />
                        <Header colSpan='8' content='West View' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='N-2/2' />
                        <Header colSpan='2' content='T-3/2' />
                        <Header colSpan='2' content='A-2/2' />
                        <Header colSpan='2' content='A-2/2' />
                        <Header colSpan='2' content='B-1/1' />
                        <Header colSpan='2' content='Z-3/3' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='2' content='1295 sq ft' />
                        <Header colSpan='2' content='1595 sq ft' />
                        <Header colSpan='2' content='1089 sq ft' />
                        <Header colSpan='2' content='1089 sq ft' />
                        <Header colSpan='2' content='792 sq ft' />
                        <Header colSpan='2' content='1446 sq ft' />
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {
                        range(22, 6, -1)
                            .filter(num => num !== 13)
                            .map(n => n.toLocaleString('en-US', {
                                minimumIntegerDigits: 2,
                                useGrouping: false
                            }))
                            .map(num => (
                                <Table.Row key={num}>
                                    <Cell unit={`${num}01`} price={renderPrice(data[`${num}01`], matrixType)} status={data[`${num}01`].status} />
                                    <Cell unit={`${num}02`} price={renderPrice(data[`${num}02`], matrixType)} status={data[`${num}02`].status} />
                                    <Cell unit={`${num}07`} price={renderPrice(data[`${num}07`], matrixType)} status={data[`${num}07`].status} />
                                    <Cell unit={`${num}05`} price={renderPrice(data[`${num}05`], matrixType)} status={data[`${num}05`].status} />
                                    <Cell unit={`${num}03`} price={renderPrice(data[`${num}03`], matrixType)} status={data[`${num}03`].status} />
                                    <EmptyCell />

                                </Table.Row>
                            ))
                    }
                    <Table.Row>
                        <EmptyCell count={4} />
                        <Cell unit={'0603'} price={renderPrice(data['0603'], matrixType)} status={data['0603'].status} />
                        <Cell unit={'0605'} price={renderPrice(data['0605'], matrixType)} status={data['0605'].status} />
                    </Table.Row>

                    <Table.Row>
                        <Cell unit={'0601'} price={renderPrice(data['0601'], matrixType)} status={data['0601'].status} />
                        <Cell unit={'0602'} price={renderPrice(data['0602'], matrixType)} status={data['0602'].status} />
                        <EmptyCell count={4} />
                    </Table.Row>

                </Table.Body>
            </Table>
        </div>
    );


};

export default BrickellFirstMatrix;
